import React, { useState, useEffect, useReducer, useRef } from 'react';
import * as Yup from 'yup';
import { Form, Formik, Field, isObject } from 'formik';
import { Link } from 'react-router-dom';

import SVG from 'react-inlinesvg';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Select } from '../../../../../../_metronic/_partials/controls';
import { toAbsoluteUrl } from '../../../../../../_metronic/_helpers';

import Numeric from '../../../../../components/Numeric';
import CheckBox from '../../../../../components/CheckBox';
import DialogBox from '../../../../../components/DialogBox';
import axios, { baseUrl } from '../../../../../../redux/my-axios';
import {
  initialSale,
  saleTypeList,
  saleStatusList,
  channelList,
  accountList,
} from '../../SalesUIHelpers';
import SalesItems from './SaleItems';
import css from './style.module.css';

const PARAM_URL = '/params';
const storageKey = 'nextDeliverDate';

function buildConfirm(state) {
  let text = 'Таны төлбөр төлөгдөж захиалга баталгаажлаа. \n';
  text =
    text +
    '\nТа доорх холбоосоор орж захиалгын дэлгэрэнгүй мэдээллээ харна уу:\n';
  text = text + state.slipLink;
  /*  if (state.items && state.items.length > 1)
    text = text + 'Сонгосон бүтээгдэхүүнүүд:\n';
  else text = text + 'Сонгосон бүтээгдэхүүн:\n';

  let i = 0;
  state.items &&
    state.items.map((item) => {
      i++;
      text =
        text +
        i.toString() +
        '. ' +
        item.brandName +
        ' ' +
        item.name +
        ' ' +
        (item.sizeValue ? item.sizeValue + ' ' : '') +
        (item.color ? '(' + item.color + ') ' : '') +
        (item.qty > 1 ? item.qty + 'ш' : '') +
        '\n';
    }); */

  if (state.saleType === 'SALE') {
    text = text + '\n\nБаярлалаа. Goyo Mart';
  } else {
    text = text + '\nЗахиалга нь ирэхээр таньд мэдэгдэх болно, баярлалаа.';
  }
  return text;
}

function buildInvoice(state) {
  let text = '';
  if (state.items && state.items.length > 1) {
    text =
      'Та дараах бүтээгдэхүүнүүдийг ' +
      (state.saleType !== 'SALE' ? 'захиалахаар' : '') +
      ' сонгосон байна:\n\n';
  } else {
    text =
      'Та дараах бүтээгдэхүүнийг ' +
      (state.saleType !== 'SALE' ? 'захиалахаар' : '') +
      ' сонгосон байна:\n\n';
  }

  let i = 0;
  state.items &&
    state.items.map((item) => {
      i++;
      text =
        text +
        i.toString() +
        '. ' +
        item.brandName +
        ' ' +
        item.name +
        (item.sizeValue ? ' ' + item.sizeValue : '') +
        (item.color ? ' (' + item.color + ')' : '') +
        (item.qty > 1
          ? '\n' +
            item.unitPrice
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') +
            '₮' +
            ' x ' +
            item.qty +
            ' = ' +
            item.totalPrice
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') +
            '₮'
          : ' - ' +
            item.unitPrice
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') +
            '₮') +
        '\n';
    });

  if (state.items && state.items.length > 1) {
    text =
      text +
      '\nБараануудын нийлбэр дүн: ' +
      state.subTotalAmount
        .toString()
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') +
      '₮';
  }
  text =
    text +
    '\nҮүн дээр хүргэлтийн ' +
    state.shipAmount
      .toString()
      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') +
    '₮ төлбөр нэмэгдэнэ.\n';

  if (state.printShipDate && state.shipDate) {
    if (state.saleType === 'SALE')
      text =
        text +
        '\n' +
        state.shipDate.toString().replaceAll('-', '.') +
        ' -ний өдөр KGB Tegbe хүргэлтээр хүргэгдэнэ. \n';
    else
      text =
        text +
        '\nТаны захиалсан бараа Монголд ирэхээр KGB Tegbe хүргэлтээр хүргэгдэнэ.\n';
  }

  if (state.printAccount) {
    text =
      text +
      '\nТөлбөр төлөх нийт дүн: ' +
      state.totalAmount
        .toString()
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') +
      '₮ болно.';
    if (state.saleType === 'SALE')
      text =
        text +
        '\nТа төлбөрөө доорх данс руу шилжүүлж худалдан авалтаа баталгаажуулна уу.\n';
    else
      text =
        text +
        '\nТа төлбөрөө доорх данс руу шилжүүлж захиалгаа баталгаажуулна уу.\n';
    text =
      text +
      '\t- Хаан Банк 5007999257 Ичинхорол\n\t- Худалдаа Хөгжлийн Банк 452431261 Ичинхорол \n';
    if (state.saleType === 'SALE') {
      text =
        text +
        '\nТөлбөрөө шилжүүлээд хүргүүлэх хаяг болон утасны дугаараа илгээгээрэй. Баярлалаа.\n\n';
      text =
        text +
        '*** Хэрэв та төлбөрөө хийж худалдан авалтаа баталгаажуулаагүй удсанд тохиолдолд таны сонгосон барааг өөр худалдан авагч сонгох боломжтой болохыг анхаарна уу ***';
    }
  }
  return text;
}

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        saleCode: action.payload.saleCode,
        refCode: action.payload.refCode,
        saleDate: action.payload.saleDate,
        saleType: action.payload.saleType,
        channel: action.payload.channel,
        custCode: action.payload.custCode,
        fbName: action.payload.fbName,
        mobile: action.payload.mobile,
        mobile2: action.payload.mobile2,
        email: action.payload.email,
        location: action.payload.location,
        district: action.payload.district,
        address: action.payload.address,
        zone: action.payload.zone,
        hold: action.payload.hold === 1 ? true : false,
        paid: action.payload.paid === 1 ? true : false,
        itemCount: action.payload.itemCount,
        status: action.payload.status,
        deposited: action.payload.deposited === 1 ? true : false,
        depositDate: action.payload.depositDate,
        subTotalAmount: parseFloat(action.payload.subTotalAmount),
        discountAmount: parseFloat(action.payload.discountAmount),
        shipAmount: parseFloat(action.payload.shipAmount),
        totalAmount: parseFloat(action.payload.totalAmount),
        depositAmount: parseFloat(action.payload.depositAmount),
        confirmed: action.payload.confirmed === 1 ? true : false,
        items: action.payload.items,
        printShipDate: action.payload.printShipDate === 1 ? true : false,
        printAccount: action.payload.printAccount === 1 ? true : false,
        note: action.payload.note,
        account: action.payload.account ? action.payload.account : '',
        invoice: action.payload.invoice,
        shipDate: '',
        profit: action.payload.profit,
        slipLink: action.payload.slipLink,
      };
    case 'setSaleCode':
      return { ...state, saleCode: action.payload };
    case 'setSaleDate':
      return { ...state, saleDate: action.payload };
    case 'setSaleType':
      return { ...state, saleType: action.payload };
    case 'setChannel':
      let shipAmountVal = state.shipAmount;
      let totalAmountVal = state.totalAmount;
      let printShipVal = state.printShipDate;
      if (action.payload === 'INPERSON') {
        totalAmountVal = state.subTotalAmount;
        shipAmountVal = 0;
        printShipVal = false;
      } else {
        shipAmountVal = 4000;
        totalAmountVal = state.subTotalAmount + shipAmountVal;
      }
      return {
        ...state,
        channel: action.payload,
        shipAmount: shipAmountVal,
        totalAmount: totalAmountVal,
        printShipDate: printShipVal,
      };
    case 'setItems':
      return {
        ...state,
        items: action.payload,
        itemCount: action.payload.length,
      };
    case 'calcSubTotalAmount':
      let sum = 0;
      let cost = 0;
      console.log(state.items);
      state.items.map((item) => {
        sum = sum + item.totalPrice;
        cost = cost + parseFloat(item.cost) * item.qty;
      });
      let totalAmount = sum;
      let profit = parseFloat(totalAmount) - cost;
      if (state.shipAmount)
        totalAmount = parseFloat(totalAmount) + parseFloat(state.shipAmount);

      return {
        ...state,
        subTotalAmount: sum,
        totalAmount: totalAmount,
        profit: profit,
      };
    case 'setShipAmount':
      return {
        ...state,
        shipAmount: parseFloat(action.payload),
      };
    case 'calcTotalAmount':
      let temp = 0;
      if (state.shipAmount)
        temp = parseFloat(temp) + parseFloat(state.shipAmount);
      if (state.subTotalAmount)
        temp = parseFloat(temp) + parseFloat(state.subTotalAmount);
      return {
        ...state,
        totalAmount: temp,
      };
    case 'setPrintShipDate':
      return {
        ...state,
        printShipDate: action.payload,
      };
    case 'setShipDate':
      return {
        ...state,
        shipDate: action.payload,
      };
    case 'setPrintAccount':
      return {
        ...state,
        printAccount: action.payload,
      };
    case 'updateInvoice':
      let text = '';
      //console.log('updateInvoice: confirmed=', state.confirmed);
      if (state.paid !== true) text = buildInvoice(state);
      else text = buildConfirm(state);
      return {
        ...state,
        invoice: text,
      };
    case 'setFbName':
      return { ...state, fbName: action.payload };
    case 'setMobile':
      return { ...state, mobile: action.payload };
    case 'setMobile2':
      return { ...state, mobile2: action.payload };
    case 'setEmail':
      return { ...state, email: action.payload };
    case 'setAddress':
      return { ...state, address: action.payload };
    case 'setHold':
      return { ...state, hold: action.payload };
    case 'setPaid':
      return { ...state, paid: action.payload };
    case 'setConfirmed':
      return {
        ...state,
        confirmed: action.payload,
      };
    case 'setDeposited':
      return {
        ...state,
        deposited: action.payload,
      };
    case 'setDepositAmount':
      return {
        ...state,
        depositAmount: action.payload,
      };
    case 'setDepositDate':
      return {
        ...state,
        depositDate: action.payload,
      };
    case 'setNote':
      return {
        ...state,
        note: action.payload,
      };
    case 'setAccount':
      return {
        ...state,
        account: action.payload,
      };
    default:
      throw new Error();
  }
}

const initialDialogData = {
  icon: 'question',
  iconColor: 'danger',
  title: 'Борлуулалтын бүртгэл',
  text:
    'Борлуулалтын бүртгэлийн өөрчлөлтөө хадгалахгүй гарахдаа итгэлтэй байна уу?',
  buttonOk: false,
  buttonYes: true,
  buttonNo: true,
  onConfirm: undefined,
};

const SaleMain = (props) => {
  const {
    intl,
    actionsLoading,
    msg,
    dialogError,
    saleForView,
    initialSale,
    btnRefSave,
    saveSale,
    newClick,
    btnRefNew,
    btnRefCancel,
    btnRefCloseOrder,
    onHide,
  } = props;

  //console.log('SaleViewForm', saleForView);
  const [state, dispatch] = useReducer(reducer, initialSale);
  const [err, setErr] = useState('');
  const [copyText, setCopyText] = useState('Copy Label');
  // States
  const [showConfirm, setShowConfirm] = useState(false);
  const [dialogData, setDialogData] = useState(initialDialogData);

  // Messages
  const AUTH_VALIDATION_MIN_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MIN_LENGTH',
  });
  const AUTH_VALIDATION_MAX_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MAX_LENGTH',
  });
  const AUTH_VALIDATION_MIN_VALUE = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MIN_VALUE',
  });
  const AUTH_VALIDATION_MAX_VALUE = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MAX_VALUE',
  });
  const AUTH_VALIDATION_REQUIRED = intl.formatMessage({
    id: 'GENERAL.VALIDATION.REQUIRED',
  });
  const SaleCreateSchema = Yup.object().shape({
    saleDate: Yup.string().required(AUTH_VALIDATION_REQUIRED),
    saleType: Yup.string().required(AUTH_VALIDATION_REQUIRED),
    fbName: Yup.string()
      .min(1, AUTH_VALIDATION_MIN_LENGTH.replace('#value#', '1'))
      .max(128, AUTH_VALIDATION_MAX_LENGTH.replace('#value#', '100'))
      .required(AUTH_VALIDATION_REQUIRED),
  });

  useEffect(() => {
    dispatch({ type: 'init', payload: saleForView });
    if (saleForView.shipDate) {
      setShipDate(saleForView.shipDate);
    } else {
      let nextDeliverDateVal = localStorage.getItem(storageKey);

      //console.log('localStorage', nextDeliverDateVal);
      let today = new Date(new Date().toISOString().slice(0, 10));
      let nextDay = new Date();

      if (nextDeliverDateVal) {
        nextDay = new Date(nextDeliverDateVal);
      }
      //console.log('Ds: ', today, nextDay);

      if (nextDay.getTime() > today.getTime()) {
        //console.log('nextDay.getTime() > today.getTime()');
        setShipDate(nextDeliverDateVal);
      } else {
        console.log('Downloading NextShipDate from DB ...');
        axios
          .post(PARAM_URL, 'getnextdeliverdate', {
            headers: { action: 'getnextdeliverdate' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                console.log('set localStorage', response.data.data);
                localStorage.setItem(storageKey, response.data.data);
                setShipDate(response.data.data);
                break;
              default:
                console.log('error', response.data);
                break;
            }
          })
          .catch((error) => {
            console.log('error', error);
          });
      }
    }
  }, [saleForView]);

  useEffect(() => {
    //console.log('SALE: ', state);
  }, [state]);

  useEffect(() => {
    setErr(dialogError);
  }, [dialogError]);

  const save = (values) => {
    //console.log('Save:', values);
    setErr('');
    if (values.deposited && !values.depositAmount) {
      setErr('Урьдчилгааны дүн талбарт утга оруулна уу!');
      return;
    }
    if (state.confirmed && !state.paid) {
      setDialogData({
        ...dialogData,
        text: 'Төлбөр төлөгдсөн тухай мэдээлэл оруулна уу!',
        buttonOk: true,
        buttonYes: false,
        buttonNo: false,
        icon: 'warning',
        iconColor: 'warning',
      });
      setShowConfirm(true);
      //alert('Төлбөр төлөгдсөн талбарыг бөглөнө үү!');
      return;
    }
    saveSale({
      ...values,
      hold: values.hold === true ? 1 : 0,
      paid: values.paid === true ? 1 : 0,
      confirmed: values.confirmed === true ? 1 : 0,
      deposited: values.deposited === true ? 1 : 0,
    });
  };

  const create = () => {
    // eniig shalgaltiig talbar burrer ni tulgaj saijruulna
    //console.log('Compare: ', saleForView, state);
    if (!msg & isChanged()) {
      setDialogData({
        ...dialogData,
        text:
          'Борлуулалтын бүртгэлийн өөрчлөлтөө хадгалахгүй гарахдаа итгэлтэй байна уу?',
        buttonOk: false,
        buttonYes: true,
        buttonNo: true,
        icon: 'question',
        iconColor: 'danger',
        onConfirm: newClick,
      });
      setShowConfirm(true);
      //setErr('Өөрчлөлтөө хадгална уу!');
    } else {
      setErr('');
      newClick();
    }
  };

  const isChanged = () => {
    //if (JSON.stringify(initialState) != JSON.stringify(state))

    if (
      saleForView.saleDate != state.saleDate ||
      saleForView.saleType != state.saleType ||
      saleForView.channel != state.channel ||
      saleForView.fbName != state.fbName ||
      saleForView.mobile != state.mobile ||
      saleForView.shipAmount != state.shipAmount ||
      saleForView.shipDate != state.shipDate ||
      saleForView.subTotalAmount != state.subTotalAmount ||
      saleForView.totalAmount != state.totalAmount ||
      saleForView.address != state.address ||
      saleForView.hold != (state.hold === true ? 1 : 0) ||
      saleForView.confirmed != (state.confirmed === true ? 1 : 0) ||
      saleForView.paid != (state.paid === true ? 1 : 0) ||
      saleForView.note != state.note ||
      saleForView.account != state.account ||
      saleForView.items.length != state.items.length
    ) {
      let changes = '';
      changes =
        changes +
        '\n saleDate is changed ' +
        (saleForView.saleDate != state.saleDate);
      changes =
        changes +
        '\n saleType is changed ' +
        (saleForView.saleType != state.saleType);
      changes =
        changes +
        '\n channel is changed ' +
        (saleForView.channel != state.channel);
      changes =
        changes +
        '\n fbName is changed ' +
        (saleForView.fbName != state.fbName);
      changes =
        changes +
        '\n mobile is changed ' +
        (saleForView.mobile != state.mobile);
      changes =
        changes +
        '\n shipAmount is changed ' +
        (saleForView.shipAmount != state.shipAmount);
      changes =
        changes +
        '\n subTotalAmount is changed ' +
        (saleForView.subTotalAmount != state.subTotalAmount);
      changes =
        changes +
        '\n totalAmount is changed ' +
        (saleForView.totalAmount != state.totalAmount);
      changes =
        changes +
        '\n address is changed ' +
        (saleForView.address != state.address);
      changes =
        changes +
        '\n hold is changed ' +
        (saleForView.hold != (state.hold === true ? 1 : 0));
      changes =
        changes +
        '\n confirmed is changed ' +
        (saleForView.confirmed != (state.confirmed === true ? 1 : 0));
      changes =
        changes +
        '\n paid is changed ' +
        (saleForView.paid != (state.paid === true ? 1 : 0));
      changes =
        changes + '\n note is changed ' + (saleForView.note != state.note);
      changes =
        changes +
        '\n account is changed ' +
        (saleForView.account != state.account);
      changes =
        changes +
        '\n items.length is changed ' +
        (saleForView.items.length != state.items.length);
      console.log('isChanged: changes=', changes, saleForView, state);
      return true;
    } else return false;
  };

  const cancel = () => {
    //console.log('cancel clicked', saleForView);
    if (!saleForView || !saleForView.saleCode) exit();
    if (isChanged()) {
      setDialogData({
        ...dialogData,
        text:
          'Борлуулалтын бүртгэлийн өөрчлөлтөө хадгалахгүй гарахдаа итгэлтэй байна уу?',
        buttonOk: false,
        buttonYes: true,
        buttonNo: true,
        icon: 'question',
        iconColor: 'danger',
        onConfirm: exit,
      });
      setShowConfirm(true);
    } else exit();
  };

  const exit = () => {
    onHide();
  };

  const setStatus = (status) => {
    dispatch({ type: 'setStatus', payload: status });
  };
  const setSaleType = (saleType) => {
    dispatch({
      type: 'setSaleType',
      payload: saleType,
    });
    dispatch({ type: 'updateInvoice', payload: '' });
  };
  const setChannel = (channel) => {
    dispatch({
      type: 'setChannel',
      payload: channel,
    });
    dispatch({ type: 'updateInvoice', payload: '' });
  };
  const setSaleDate = (saleDate) => {
    dispatch({ type: 'setSaleDate', payload: saleDate });
  };

  const updateSubTotalAmount = (items) => {
    dispatch({ type: 'setItems', payload: items });
    dispatch({ type: 'calcSubTotalAmount', payload: '' });
    dispatch({ type: 'updateInvoice', payload: '' });
  };

  const setShipAmount = (shippingAmount) => {
    dispatch({
      type: 'setShipAmount',
      payload: parseFloat(shippingAmount),
    });
    dispatch({ type: 'calcTotalAmount', payload: '' });
    dispatch({ type: 'updateInvoice', payload: '' });
  };

  const setPrintShipDate = (checked) => {
    dispatch({
      type: 'setPrintShipDate',
      payload: checked,
    });
    dispatch({ type: 'updateInvoice', payload: '' });
  };
  const setShipDate = (date) => {
    //console.log('setShipDate', date);
    dispatch({
      type: 'setShipDate',
      payload: date,
    });
    dispatch({ type: 'updateInvoice', payload: '' });
    localStorage.setItem(storageKey, date);
  };

  const setPrintAccount = (checked) => {
    dispatch({
      type: 'setPrintAccount',
      payload: checked,
    });
    dispatch({ type: 'updateInvoice', payload: '' });
  };
  const setFbName = (fbName) => {
    dispatch({
      type: 'setFbName',
      payload: fbName,
    });
  };

  const setMobile = (mobile) => {
    dispatch({
      type: 'setMobile',
      payload: mobile,
    });
  };

  const setMobile2 = (mobile2) => {
    dispatch({
      type: 'setMobile2',
      payload: mobile2,
    });
  };

  const setEmail = (email) => {
    dispatch({
      type: 'setEmail',
      payload: email,
    });
  };

  const setAddress = (address) => {
    dispatch({
      type: 'setAddress',
      payload: address,
    });
  };

  const setHold = (checked) => {
    dispatch({
      type: 'setHold',
      payload: checked,
    });
  };

  const setPaid = (checked) => {
    dispatch({
      type: 'setPaid',
      payload: checked,
    });
    dispatch({ type: 'updateInvoice', payload: '' });
  };
  const setConfirmed = (checked) => {
    if (state.saleType === 'SALE' && !state.mobile) {
      setDialogData({
        ...dialogData,
        text: 'Худалдан авагчийн утасны дугаар оруулна уу!',
        buttonOk: true,
        buttonYes: false,
        buttonNo: false,
        icon: 'warning',
        iconColor: 'warning',
      });
      setShowConfirm(true);
      return;
    }

    if (state.saleType === 'SALE' && !state.address) {
      setDialogData({
        ...dialogData,
        text: 'Хүлээн авах хаяг оруулна уу!',
        buttonOk: true,
        buttonYes: false,
        buttonNo: false,
        icon: 'warning',
        iconColor: 'warning',
      });
      setShowConfirm(true);
      return;
    }

    setErr('');
    dispatch({
      type: 'setConfirmed',
      payload: checked,
    });
  };
  const setDeposited = (checked) => {
    dispatch({
      type: 'setDeposited',
      payload: checked,
    });
  };
  const setDepositAmount = (amount) => {
    dispatch({
      type: 'setDepositAmount',
      payload: amount,
    });
  };

  const setDepositDate = (date) => {
    dispatch({
      type: 'setDepositDate',
      payload: date,
    });
  };

  const handleChange = (event) => {
    setSaleDate(event.target.value);
  };

  const handleChange1 = (event) => {
    setShipDate(event.target.value);
  };

  const handleChangeDipositDate = (event) => {
    setDepositDate(event.target.value);
  };

  const setNote = (note) => {
    dispatch({
      type: 'setNote',
      payload: note,
    });
  };

  const setAccount = (account) => {
    dispatch({
      type: 'setAccount',
      payload: account,
    });
  };

  const copy = async () => {
    await navigator.clipboard.writeText(
      state.mobile2
        ? `${state.fbName}\n${state.mobile}\n${
            state.mobile2 ? state.mobile2 : ''
          }`
        : `${state.fbName}\n${state.mobile}`
    );
    setCopyText('Copied');
  };

  const handleFocus = (event) => event.target.select();
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={state}
        validationSchema={SaleCreateSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({ errors, touched, handleBlur, isValidating }) => (
          <>
            <Form className='form form-label-right' size='sm'>
              {err ? (
                <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{err}</div>
                </div>
              ) : (
                <div></div>
              )}
              {msg ? (
                <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{msg}</div>
                </div>
              ) : (
                <div></div>
              )}
              <div className={css.main}>
                <div className={css.items}>
                  <div id='saleStatus' className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Төлөв:{' '}
                    </label>
                    <Select
                      name='status'
                      className='form-control form-control-sm'
                      onChange={(e) => {
                        setStatus(e.target.value);
                      }}
                      disabled={true}
                    >
                      {saleStatusList.map((option) => (
                        <option
                          key={`saleStatusList${option.key}`}
                          value={option.key}
                        >
                          {option.value}
                        </option>
                      ))}
                    </Select>
                  </div>
                  <div id='saleType' className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Төрөл:{' '}
                    </label>
                    <Select
                      name='saleType'
                      className='form-control form-control-sm'
                      onChange={(e) => {
                        setSaleType(e.target.value);
                      }}
                      disabled={saleForView.confirmed === 1 ? true : false}
                    >
                      {saleTypeList.map((option) => (
                        <option
                          key={`saleTypeList${option.key}`}
                          value={option.key}
                        >
                          {option.value}
                        </option>
                      ))}
                    </Select>
                  </div>
                  {saleForView.refCode && (
                    <div id='refCodeDiv' className={css.row}>
                      <label style={{ display: 'flex', width: '140px' }}>
                        {saleForView.saleType === 'SALE'
                          ? 'Захиалгын дугаар: '
                          : 'Борлуулалтын дугаар: '}
                      </label>
                      <Link to={`/sales/${saleForView.refCode}/edit`}>
                        {saleForView.refCode}
                      </Link>
                    </div>
                  )}
                  <div id='channel' className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Суваг:{' '}
                    </label>
                    <Select
                      name='channel'
                      className='form-control form-control-sm'
                      onChange={(e) => {
                        setChannel(e.target.value);
                      }}
                      disabled={saleForView.confirmed === 1 ? true : false}
                    >
                      {channelList.map((option) => (
                        <option
                          key={`channelList${option.key}`}
                          value={option.key}
                        >
                          {option.value}
                        </option>
                      ))}
                    </Select>
                  </div>
                  <div id='saleDate' className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Борлуулсан:{' '}
                    </label>
                    <input
                      id='saleDate'
                      type='date'
                      className='form-control form-control-sm'
                      value={state.saleDate}
                      onChange={handleChange}
                      disabled={saleForView.confirmed === 1 ? true : false}
                    />
                    {errors.saleDate && touched.saleDate ? (
                      <div>{errors.saleDate}</div>
                    ) : null}
                  </div>
                  <SalesItems
                    className={css.items}
                    sale={saleForView}
                    updateSubTotalAmount={updateSubTotalAmount}
                  />
                </div>
                <div className={css.detail}>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Нийлбэр дүн:{' '}
                    </label>
                    <Numeric
                      id='subTotalAmount'
                      name='subTotalAmount'
                      value={state.subTotalAmount}
                      className='form-control form-control-sm'
                      disabled={true}
                      decimalScale='0'
                      type='text'
                      fixedDecimalScale={false}
                      defaultValue='0'
                      decimalSeparator=''
                    />

                    {errors.subTotalAmount && touched.subTotalAmount ? (
                      <div>{errors.subTotalAmount}</div>
                    ) : null}
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Хүргэлт:{' '}
                    </label>
                    <Numeric
                      id='saleShipAmount'
                      name='shipAmount'
                      value={state.shipAmount}
                      className='form-control form-control-sm'
                      decimalScale='0'
                      fixedDecimalScale={false}
                      defaultValue='0'
                      onChange={(e) => {
                        setShipAmount(e);
                      }}
                      disabled={
                        state.channel === 'INPERSON' ||
                        saleForView.confirmed === 1
                          ? true
                          : false
                      }
                    />
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Нийт дүн:{' '}
                    </label>
                    <Numeric
                      id='totalAmount'
                      name='totalAmount'
                      value={state.totalAmount}
                      className='form-control form-control-sm'
                      disabled={true}
                      decimalScale='0'
                      fixedDecimalScale={false}
                      defaultValue='0'
                      onChange={(e) => {
                        //console.log(e);
                      }}
                    />

                    {errors.totalAmount && touched.totalAmount ? (
                      <div>{errors.totalAmount}</div>
                    ) : null}
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Ашиг:{' '}
                    </label>
                    <Numeric
                      id='profit'
                      name='profit'
                      value={state.profit}
                      className='form-control form-control-sm'
                      disabled={true}
                      decimalScale='0'
                      fixedDecimalScale={false}
                      defaultValue='0'
                      onChange={(e) => {
                        //console.log(e);
                      }}
                    />
                  </div>

                  {state.channel === 'FACEBOOK' && (
                    <>
                      <div id='printShipDate' className={css.row}>
                        <CheckBox
                          name='printShipDate'
                          className='form-control form-control-sm'
                          text='Хүргэлттэй'
                          checked={state.printShipDate}
                          changeCheckBoxValue={(e) => {
                            setPrintShipDate(e);
                          }}
                          disabled={state.channel === 'INPERSON'}
                        />
                        <input
                          id='shipDate'
                          type='date'
                          className='form-control form-control-sm'
                          value={state.shipDate}
                          onChange={handleChange1}
                        />
                      </div>
                      <div id='printAccount' className={css.row}>
                        <CheckBox
                          name='printAccount'
                          className='form-control form-control-sm'
                          text='Данстай'
                          checked={state.printAccount}
                          changeCheckBoxValue={(e) => {
                            setPrintAccount(e);
                          }}
                        />
                      </div>
                    </>
                  )}

                  <div className={css.row}>
                    <Field
                      name='invoce'
                      value={state.invoice}
                      className='form-control form-control-sm'
                      as='textarea'
                      multiple
                      rows='10'
                      onFocus={handleFocus}
                      readOnly={true}
                    />
                  </div>
                  <div className={css.row}>
                    <CheckBox
                      name='hold'
                      className='form-control form-control-sm'
                      text='Нэхэмжлэл илгээсэн'
                      checked={state.hold}
                      changeCheckBoxValue={(e) => {
                        setHold(e);
                      }}
                      disabled={saleForView.confirmed === 1 ? true : false}
                    />
                  </div>
                  <div className={css.row}>
                    <CheckBox
                      name='paid'
                      className='form-control form-control-sm'
                      text='Төлбөр төлсөн'
                      checked={state.paid}
                      changeCheckBoxValue={(e) => {
                        setPaid(e);
                      }}
                      disabled={saleForView.confirmed === 1 ? true : false}
                    />
                  </div>
                  {state.paid && (
                    <div id='account' className={css.row}>
                      <Select
                        name='account'
                        className='form-control form-control-sm'
                        onChange={(e) => {
                          setAccount(e.target.value);
                        }}
                      >
                        {accountList.map((option) => (
                          <option
                            key={`accountList${option.key}`}
                            value={option.key}
                          >
                            {option.value}
                          </option>
                        ))}
                      </Select>
                    </div>
                  )}
                  {state.saleType === 'ORDER' ? (
                    <>
                      <div className={css.row}>
                        <CheckBox
                          name='deposited'
                          className='form-control form-control-sm'
                          text='Урьдчилгаа төлсөн'
                          checked={state.deposited}
                          changeCheckBoxValue={(e) => {
                            setDeposited(e);
                          }}
                        />
                      </div>
                      {state.deposited && (
                        <>
                          <div className={css.row}>
                            <label style={{ display: 'flex', width: '140px' }}>
                              Урьдчилгаа:
                            </label>
                            <Numeric
                              id='depositAmount'
                              name='depositAmount'
                              value={state.depositAmount}
                              className='form-control form-control-sm'
                              decimalScale='0'
                              fixedDecimalScale={false}
                              defaultValue='0'
                              onChange={(e) => {
                                setDepositAmount(e);
                              }}
                            />
                          </div>
                          <div id='depositDate' className={css.row}>
                            <label style={{ display: 'flex', width: '140px' }}>
                              Урьдчилгаа төлсөн:
                            </label>
                            <input
                              id='depositDate'
                              type='date'
                              className='form-control form-control-sm'
                              value={state.depositDate}
                              onChange={handleChangeDipositDate}
                            />
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Нэр:{' '}
                    </label>
                    <Field
                      name='fbName'
                      className='form-control form-control-sm'
                      placeholder='FB нэр'
                      onBlur={(e) => {
                        setFbName(e.target.value);
                      }}
                    />
                  </div>
                  <div className={css.row}>
                    {errors.fbName && touched.fbName ? (
                      <div className='text-danger'>*{errors.fbName}</div>
                    ) : null}
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Утас дугаар:{' '}
                    </label>
                    <Field
                      name='mobile'
                      className='form-control form-control-sm'
                      placeholder='Утасны дугаар'
                      onBlur={(e) => {
                        setMobile(e.target.value);
                      }}
                    />
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Утас дугаар2:{' '}
                    </label>
                    <Field
                      name='mobile2'
                      className='form-control form-control-sm'
                      placeholder='Утасны дугаар2'
                      onBlur={(e) => {
                        setMobile2(e.target.value);
                      }}
                    />
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Имэйл:{' '}
                    </label>
                    <Field
                      name='email'
                      className='form-control form-control-sm'
                      placeholder='Имэйл'
                      onBlur={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Байршил:{' '}
                    </label>
                    <Field
                      name='location'
                      className='form-control form-control-sm'
                      placeholder='Байршил'
                      disabled
                    />
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Дүүрэг:{' '}
                    </label>
                    <Field
                      name='district'
                      className='form-control form-control-sm'
                      placeholder='Дүүрэг/Аймаг'
                      disabled
                    />
                  </div>

                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Хаяг:{' '}
                    </label>
                    <Field
                      name='address'
                      className='form-control form-control-sm'
                      placeholder='Хүлээн авах хаяг'
                      as='textarea'
                      rows='3'
                      onBlur={(e) => {
                        setAddress(e.target.value);
                      }}
                    />
                  </div>
                  <div className={css.row}>
                    <CheckBox
                      name='confirmed'
                      className='form-control form-control-sm'
                      text='Баталгаажсан'
                      checked={state.confirmed}
                      changeCheckBoxValue={(e) => {
                        setConfirmed(e);
                      }}
                      disabled={saleForView.confirmed === 1}
                    />
                  </div>
                  <div className={css.row}>
                    <label style={{ display: 'flex', width: '140px' }}>
                      Тэмдэглэл:{' '}
                    </label>
                    <Field
                      name='note'
                      className='form-control form-control-sm'
                      placeholder='Тэмдэглэл'
                      as='textarea'
                      rows='3'
                      onBlur={(e) => {
                        setNote(e.target.value);
                      }}
                    />
                  </div>
                  <div className={css.row}>
                    <button className='btn btn-light sm-1' onClick={copy}>
                      {copyText}
                    </button>
                  </div>
                </div>
              </div>
              {showConfirm && (
                <DialogBox
                  openDialog={showConfirm}
                  setOpenDialog={setShowConfirm}
                  icon={dialogData.icon}
                  iconColor={dialogData.iconColor}
                  title={dialogData.title}
                  text={dialogData.text}
                  buttonOk={dialogData.buttonOk}
                  buttonYes={dialogData.buttonYes}
                  buttonNo={dialogData.buttonNo}
                  onConfirm={dialogData.onConfirm}
                ></DialogBox>
              )}
              <button
                type='submit'
                style={{ display: 'none' }}
                ref={btnRefSave}
              ></button>
              <button
                type='button'
                style={{ display: 'none' }}
                ref={btnRefNew}
                onClick={() => create()}
              ></button>
              <button
                type='button'
                onClick={cancel}
                ref={btnRefCancel}
                style={{ display: 'none' }}
              >
                cancel
              </button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default injectIntl(SaleMain);
